/** Objet JSON dans documents.hidden_fournisseur_fields (bon de livraison). */
export const BON_SORTIE_TRANSPORT_HIDDEN_KEY = 'informations_transport';

export interface BonSortieTransportInfo {
  transporteur?: string;
  chauffeur?: string;
  immatriculation_vehicule?: string;
  telephone_chauffeur?: string;
  adresse_destination?: string;
}

export const BON_SORTIE_TRANSPORT_FIELD_DEFS: ReadonlyArray<{
  key: keyof BonSortieTransportInfo;
  label: string;
}> = [
  { key: 'transporteur', label: 'Transporteur' },
  { key: 'chauffeur', label: 'Chauffeur' },
  { key: 'immatriculation_vehicule', label: 'Immatriculation véhicule' },
  { key: 'telephone_chauffeur', label: 'Téléphone chauffeur' },
  { key: 'adresse_destination', label: 'Adresse destination' },
];

function parseHiddenFournisseur(raw: unknown): Record<string, unknown> | null {
  if (!raw) {
    return null;
  }
  if (typeof raw === 'string') {
    try {
      const p = JSON.parse(raw);
      return p && typeof p === 'object' ? (p as Record<string, unknown>) : null;
    } catch {
      return null;
    }
  }
  return typeof raw === 'object' ? (raw as Record<string, unknown>) : null;
}

export function emptyBonSortieTransportInfo(): BonSortieTransportInfo {
  return {
    transporteur: '',
    chauffeur: '',
    immatriculation_vehicule: '',
    telephone_chauffeur: '',
    adresse_destination: '',
  };
}

export function normalizeBonSortieTransportInfo(raw: unknown): BonSortieTransportInfo {
  const base = emptyBonSortieTransportInfo();
  if (!raw || typeof raw !== 'object') {
    return base;
  }
  const src = raw as Record<string, unknown>;
  for (const def of BON_SORTIE_TRANSPORT_FIELD_DEFS) {
    const v = src[def.key];
    if (v != null && String(v).trim() !== '') {
      base[def.key] = String(v).trim();
    }
  }
  return base;
}

/** Lit les infos transport depuis un document API (hidden_fournisseur_fields). */
export function parseBonSortieTransportInfoFromDoc(doc: any): BonSortieTransportInfo {
  const hidden = parseHiddenFournisseur(doc?.hidden_fournisseur_fields);
  if (!hidden) {
    return emptyBonSortieTransportInfo();
  }
  const nested = hidden[BON_SORTIE_TRANSPORT_HIDDEN_KEY];
  if (nested && typeof nested === 'object') {
    return normalizeBonSortieTransportInfo(nested);
  }
  return normalizeBonSortieTransportInfo(hidden);
}

export function mergeBonSortieTransportIntoHiddenFournisseur(
  hidden: Record<string, unknown> | null | undefined,
  info: BonSortieTransportInfo
): Record<string, unknown> {
  const out = hidden && typeof hidden === 'object' ? { ...hidden } : {};
  const cleaned: BonSortieTransportInfo = {};
  for (const def of BON_SORTIE_TRANSPORT_FIELD_DEFS) {
    const v = info[def.key];
    if (v != null && String(v).trim() !== '') {
      cleaned[def.key] = String(v).trim();
    }
  }
  const hasAny = BON_SORTIE_TRANSPORT_FIELD_DEFS.some((d) => !!cleaned[d.key]);
  if (hasAny) {
    out[BON_SORTIE_TRANSPORT_HIDDEN_KEY] = cleaned;
  } else {
    delete out[BON_SORTIE_TRANSPORT_HIDDEN_KEY];
  }
  return out;
}

export function formatBonSortieTransportDisplayValue(
  info: BonSortieTransportInfo,
  key: keyof BonSortieTransportInfo
): string {
  const v = info[key];
  const s = v != null ? String(v).trim() : '';
  return s || '—';
}
